import React from 'react'
import { Update } from './update'

export  const Updates = () => {
    return (
        <div>
            <Update />
        </div>
    )
}
